import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { AiModelsService } from './api/ai-models.service';
import { AiModelsActions } from './ai-models.actions';

export class AiModelsEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(AiModelsService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AiModelsActions.getAIModels),
      switchMap(({ tenantUuid, aiProviderUuidList }) =>
        this.svc.getAiModels(tenantUuid).pipe(
          map((aiModels) => AiModelsActions.loadSuccess({ aiModels })),
          catchError((error) => of(AiModelsActions.loadFailure({ error }))),
        ),
      ),
    ),
  );
}
